import { DialogType } from '@tableau/widgets';
import React from 'react';

import { ModalInstance, ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { Messages } from '~src/codegen/Localize';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { AddUsersFromIdentityPoolButtonProps } from './AddUsersFromIdentityPoolButton';
import { AddUsersFromIdentityPoolDialog } from './AddUsersFromIdentityPoolDialog';

const DIALOG_TESTID = 'add-users-from-identity-pool-dialog';

export class AddUsersFromIdentityPoolAction {
  public static readonly instance = new AddUsersFromIdentityPoolAction();

  public showAddUserFromIdentityPoolDialog(props: AddUsersFromIdentityPoolButtonProps): Promise<any> {

    let modalInstance: ModalInstance;

    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss(),
      close: (result: any) => modalInstance && modalInstance.close(result),
      ...props,
    };

    modalInstance = ReactModalService.open({
      type: DialogType.NormalWithTitleBar,
      dialogContent: React.createElement(AddUsersFromIdentityPoolDialog, dialogProps),
      testId: DIALOG_TESTID,
      showCloseButton: true,
      disableAutoFocus: dialogElement => dialogElement.querySelector('button[aria-haspopup]'),
      title: Messages.identityPools_AddUsersDialog_Title(),
      dialogWidth: TabDialogWidth.width500px
    });

    return modalInstance.result;
  }
}

export default AddUsersFromIdentityPoolAction.instance;
